module.exports = "https://sf16-website.neutral.ttwstatic.com/obj/tiktok_web_static/bytecom/api_gateway_web_i18n/static/media/admin_type_2.b69a84b0.svg";